import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import auth from '../../services/auth/auth'

// Authentication guard
export const requireAuth = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (!auth.isAuthenticated()) {
    // Save the original URL including query parameters
    const targetUrl = to.fullPath
    next({
      path: '/login',
      query: { redirect: targetUrl }
    })
  } else {
    next()
  }
}

// Already authenticated guard (for login page)
export const redirectIfAuth = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
) => {
  if (auth.isAuthenticated()) {
    // Check for redirect query parameter first
    const redirectPath = to.query.redirect as string
    if (redirectPath) {
      next({ path: redirectPath })
    } else {
      // Check sessionStorage for saved redirect (from OAuth flow)
      const savedRedirect = sessionStorage.getItem('authentik_redirect_to')
      if (savedRedirect) {
        sessionStorage.removeItem('authentik_redirect_to')
        next({ path: savedRedirect })
      } else {
        next({ path: '/' })
      }
    }
  } else {
    next()
  }
}
